import Memorandum from "src/components/feature/Memorandum";

const DefaultMemorandum = () => {
  return <Memorandum />;
};

export default DefaultMemorandum;